import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router";
import { useAppSelector } from "../app/hooks";
import { isAdminRole } from "../app/userSlice";

export default function RequireAdmin() {
	const role = useAppSelector((state) => state.user.role);
	const navigate = useNavigate();

	useEffect(() => {
		if (!isAdminRole(role)) {
			navigate("/home");
		}
	});

	return <Outlet />;
}
